import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

const state = {
  Login_Usuario: {
    TituloYNombreCompleto: "Sin usuario",
    ContraseñaVerificada: null,
    Foto: null,
    Iniciales: null,
    MenuPrincipal: [],
    Sistemas: [], 
    Area: null, 
    Puesto: null, 
  },
  Login_TiempoDeVerificacionId: null,
  Login_AutorizacionOriginal: null, 
  Login_SeHaPreguntadoIniciarSesion: false,
  Login_PermisosDelSistema: [],
  Login_TareasCumplidas: {
    ValidaSesion: null,
    ObtenDatos: null,
    ObtenPermisosDelSistema: null,
    ObtenPermisoDeLaVentana: null,
    ObligarAMoverseAAlgunaPagina: null
  },
  Login_PaginaPrevia: null, 
  Login_Meta: null, 
  Login_ListadoDeAyuda: null
}

const getter = {
  Get_AreaDelUsuario: state => {
    if (state.Login_Usuario.Area != null)
      return {
        AreaId: state.Login_Usuario.Area.AreaId, 
        Nombre: state.Login_Usuario.Area.Nombre, 
        Abreviatura: state.Login_Usuario.Area.Abreviatura
      }
    else {
      return null;
    }
  }, 
  Get_PuestoDelUsuario: state => {
    if (state.Login_Usuario.Puesto != null)
      return {
        AreaId: state.Login_Usuario.Puesto.PuestoJuridicoId, 
        Nombre: state.Login_Usuario.Puesto.Nombre
      }
    else {
      return null;
    }
  } 
}

const mutations = {
  M_ReglasDeRuteo(state, data) {
    if(data.cargaDesdeRouter != undefined && data.cargaDesdeRouter) {
      state.Login_TareasCumplidas.ObligarAMoverseAAlgunaPagina = data.aDondeSeRuteaOElError;
    } else {
      switch(data.aDondeSeRuteaOElError) {
        case 1:
          router.push({ path: "/Login" });
          break;
        case 12:
          //if(state.Login_PaginaPrevia != null) {
            //if(state.Login_PaginaPrevia.fullPath == "/")
              //router.push({ path: "/Tablero/Bienvenida" });
            //else
              //router.push({ path: state.Login_PaginaPrevia.fullPath })
          //} else {
            //router.push({ path: "/Tablero/Bienvenida" });
          //}
          break;
        case 14:
          mutations.M_ComprobarSesionEnLocalStorage(state, data);
          break;
      }
    }
  },
  M_SeNecesitaVerificarLaSesionDelUsuario(state, data) {
    comun.EsNecesarioRecargarLaPagina(true);
    comun.SeEstaRecargandoLaSesion(false);

    if(data.ValidarUsuario) {
      state.Login_Usuario = {
        TituloYNombreCompleto: "Sin usuario",
        Foto: null,
        Iniciales: null,
        MenuPrincipal: [],
        Sistemas: []
      };
    }

    if(data.ValidarSistemaQueIngreso) {
      state.Login_PermisosDelSistema = [];
    }
  },
  M_ComprobarElTipoDeSesionRequerido(state, data) {
    let headerDeAcceso = null;
    if(data.RequiereAutenticacion || (localStorage.getItem("Authorization") != undefined && localStorage.getItem("Authorization") != null)) {
      comun.ConAutenticacion(true);
      headerDeAcceso = mutations.M_ComprobarSesionEnLocalStorage(state, data);
    } else {
      comun.ConAutenticacion(false);
      if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
        headerDeAcceso = {
          headers: {
            Authorization: "Authentication-Authorized",
            Expiration: moment().add(1, 'minutes').format("YYYY-MM-DDTHH:mm:ss.SSSZ")
          }
        }

        if(state.TiempoDeVerificacionId != null && state.TiempoDeVerificacionId != undefined) 
          clearInterval(state.TiempoDeVerificacionId);
      }
    }

    return headerDeAcceso;
  },
  M_ComprobarSesionEnLocalStorage(state, data) {
    const header = {
      headers: {}
    };
    
    if (localStorage.getItem("Authorization") != undefined && localStorage.getItem("Authorization") != null) {
      const verificarQueSeaIdentico = localStorage.getItem("Authorization");
      if (state.Login_AutorizacionOriginal == null)
        state.Login_AutorizacionOriginal = verificarQueSeaIdentico;

      if (state.Login_AutorizacionOriginal == verificarQueSeaIdentico) {
        const autenticacion = JSON.parse(verificarQueSeaIdentico);

        if(moment().isAfter(autenticacion.ExpirationDate)) {
          const parametrosParaVerificar = {
            ValidarUsuario: true,
            ValidarSistemaQueIngreso: true
          };
          mutations.M_SeNecesitaVerificarLaSesionDelUsuario(state, parametrosParaVerificar);

          if(state.Login_SeHaPreguntadoIniciarSesion == null || state.Login_SeHaPreguntadoIniciarSesion == undefined) {
            localStorage.removeItem('Authorization');

            if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
              comun.mensajeDeAlerta("El usuario que esta en el sistema no cuenta con una sesión activa.<br />Inicie sesión de nuevo para poder continuar con sus actividades.", null, null);
              data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;
              mutations.M_ReglasDeRuteo(state, data);
            }
          } else {
            //if(!state.Login_SeHaPreguntadoIniciarSesion) {
              state.Login_SeHaPreguntadoIniciarSesion = true;

              $('.bootbox.modal').modal('hide');
              bootbox.confirm({
                title: "Mensaje del sistema",
                message: "El usuario que esta en el sistema no cuenta con una sesión activa.<br />¿Desea continuar con la sesión?.",
                buttons: {
                  cancel: {
                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No y cerrar'
                  },
                  confirm: {
                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar con la sesión'
                  }
                },
                callback: async function (respuesta) {
                  if (respuesta) {
                    const caduca = moment().add(8, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                    const token = {
                      Token: autenticacion.Token,
                      ExpirationDate: caduca
                    };
                    localStorage.setItem("Authorization", JSON.stringify(token));
                    state.Login_AutorizacionOriginal = JSON.stringify(token);
                    if(comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
                      router.push({ path: "/Tablero/Bienvenida" });
                    } else
                      await mutations.M_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema(state, data);
                  } else {
                    localStorage.removeItem('Authorization');
                    comun.mensajeDeAlerta("La sesión ha sido finalizada correctamente.", null, null)

                    if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
                      data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;
                      mutations.M_ReglasDeRuteo(state, data);
                    }
                  }
                  state.Login_SeHaPreguntadoIniciarSesion = false;
                }
              });
            //}
          }

          data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.NoEsRedirigida;
          mutations.M_ReglasDeRuteo(state, data);
          return null;
        } else {
          if(comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
            data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.YaTieneSesion;
            mutations.M_ReglasDeRuteo(state, data);
          } else {
            header.headers.Authorization = autenticacion.Token;
            header.headers.Expiration = autenticacion.ExpirationDate;
            return header;
          }
        }
      } else {
        localStorage.removeItem('Authorization');
        comun.mensajeDeAlerta("La sesión no coincide con la original.<br />Se ha cerrado su sesión por motivos de seguridad.", null, null)

        switch (data.cargaDesdeRouter) {
          case true:
            if(router.history.pending.fullPath != "/Login") {
              data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;
              mutations.M_ReglasDeRuteo(state, data);
            }
            break;
          default:
            if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
              data.aDondeSeRuteaOElError = 1;
              mutations.M_ReglasDeRuteo(state, data);
            }
            break;
        }
      }
    } else {
      switch (data.cargaDesdeRouter) {
        case true:
          if(router.history.pending.fullPath != "/Login") {
            comun.mensajeDeAlerta("El usuario que esta en el sistema no cuenta con una sesión activa.<br />Inicie sesión de nuevo para poder continuar con sus actividades.", null, null);
            data.aDondeSeRuteaOElError = enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;
            mutations.M_ReglasDeRuteo(state, data);
          }
          break;
        default:
          if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) {
            comun.mensajeDeAlerta("El usuario que esta en el sistema no cuenta con una sesión activa.<br />Inicie sesión de nuevo para poder continuar con sus actividades.", null, null);
            data.aDondeSeRuteaOElError = 1;
            mutations.M_ReglasDeRuteo(state, data);
          }
          break;
      }

      return null;
    }
  },
  M_IniciarYCrearLaSesionEnLocalStorage(state, data) {
    comun.SeEstaIniciandoSesion(true);
    
    axios.post(
      api.conexion + api.Login.funcion.IniciarSesion,
        data
        ).then(respuesta => {
          if(respuesta.data.SiHayError){
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            comun.SeEstaIniciandoSesion(false);
          } else {
            const caduca = moment().add(8, 'hours').format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            const token = {
              Token: respuesta.data.Token,
              ExpirationDate: caduca
            };

            localStorage.setItem("Authorization", JSON.stringify(token));
            state.Login_AutorizacionOriginal = JSON.stringify(token);
            router.push({ path: "/Tablero/Bienvenida" });
          }
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaIniciandoSesion(false);
        });
  },
  M_ConfirmacionParaCerrarSesion(state, data) {
    $('.bootbox.modal').modal('hide');
    bootbox.confirm({
      title: "Mensaje del sistema",
      message: data.mensaje,
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + data.textoDeCancelacion
        },
        confirm: {
          label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + data.textoDeConfirmacion
        }
      },
      callback: function (respuesta) {
        if (respuesta) {
          localStorage.removeItem('Authorization');
          comun.mensajeDeAlerta("La sesión ha sido finalizada correctamente.", null, null)
    
          router.push({ path: "/Login" });
        }
      }
    });
  },
  async M_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema(state, data) {
    return new Promise(async (resultado, rechazo) => {
      comun.SeEstaRecargandoLaSesion(true);
      state.Login_TareasCumplidas = {
        ValidaSesion: null,
        ObtenDatos: null,
        ObtenPermisosDelSistema: null,
        ObtenPermisoDeLaVentana: null,
        ObligarAMoverseAAlgunaPagina: null
      };
      state.Login_PermisosDelSistema = [];
      
      if (data.CargaInformacionDePaginaActual) {
        data = router.currentRoute.meta;
        data.cargaDesdeRouter = false;
      } else {
        data.cargaDesdeRouter = true;
      }

      if (data.SistemaQueSeIngreso != null && data.SistemaQueSeIngreso != undefined && data.SistemaQueSeIngreso > 0) {
        comun.EsNecesarioElTablero(true);
      } else {
        comun.EsNecesarioElTablero(false);
      }
      data.comprobacionDeLocalStorage = mutations.M_ComprobarElTipoDeSesionRequerido(state, data);

      if (data.comprobacionDeLocalStorage != null && data.comprobacionDeLocalStorage != undefined) {
        if (data.ValidaSesion != undefined && data.ValidaSesion != null && data.ValidaSesion) {
          await mutations.M_ValidaSesion(state, data)
            .then(respuesta => {
              if(respuesta == undefined){
                state.Login_TareasCumplidas.ObtenPermisosDelSistema = null;
                state.Login_TareasCumplidas.ObtenPermisoDeLaVentana = null;
                state.Login_TareasCumplidas.ObligarAMoverseAAlgunaPagina = null;
              } else if(respuesta.data.SiHayError){
                console.log(respuesta);
                const parametrosParaVerificar = {
                  ValidarUsuario: true,
                  ValidarSistemaQueIngreso: true
                };
                mutations.M_SeNecesitaVerificarLaSesionDelUsuario(state, parametrosParaVerificar);

                state.Login_TareasCumplidas.ValidaSesion = false;

                if(!comun.YaEstaADondeSeEstaDirigiendo(router, "/Login")) 
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);

                data.aDondeSeRuteaOElError = respuesta.data.Error.MensajeId;
                mutations.M_ReglasDeRuteo(state, data);
              } else {
                state.Login_TareasCumplidas.ValidaSesion = true;
                if (data.comprobacionDeLocalStorage.headers.Authorization != "Authentication-Authorized") {
                  comun.EsNecesarioRecargarLaPagina(false);
                  comun.SeEstaRecargandoLaSesion(false);
                }
                if(data.ObtenDatos != undefined && data.ObtenDatos != null && data.ObtenDatos) {
                  state.Login_TareasCumplidas.ObtenDatos = true;
                  state.Login_Usuario = respuesta.data;

                  comun.EsNecesarioCambiarLaContrasena(state.Login_Usuario.ContraseñaVerificada);
                }
              }
            })
            .catch(exception => { });
        }

        if ((data.ObtenPermisosDelSistema != undefined && data.ObtenPermisosDelSistema != null && data.ObtenPermisosDelSistema) && 
          (data.SistemaQueSeIngreso != null && data.SistemaQueSeIngreso != undefined && data.SistemaQueSeIngreso > 0)) {
          await mutations.M_ObtenPermisosDelSistema(state, data)
            .then(respuesta => {
              if(respuesta == undefined){
                state.Login_TareasCumplidas.ObtenPermisoDeLaVentana = null;
                state.Login_TareasCumplidas.ObligarAMoverseAAlgunaPagina = null;
              } else if(respuesta.data.SiHayError){
                console.log(respuesta);
                const parametrosParaVerificar = {
                  ValidarUsuario: false,
                  ValidarSistemaQueIngreso: true
                };
                mutations.M_SeNecesitaVerificarLaSesionDelUsuario(state, parametrosParaVerificar);

                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                state.Login_TareasCumplidas.ObtenPermisosDelSistema = false;

                data.aDondeSeRuteaOElError = respuesta.data.Error.MensajeId;
                mutations.M_ReglasDeRuteo(state, data);
              } else {
                state.Login_TareasCumplidas.ObtenPermisosDelSistema = true;
                if (data.comprobacionDeLocalStorage.headers.Authorization != "Authentication-Authorized") {
                  comun.EsNecesarioRecargarLaPagina(false);
                  comun.SeEstaRecargandoLaSesion(false);
                  
                  state.Login_PermisosDelSistema = respuesta.data.Permisos;
                  mutations.M_AsignaElListadoDeAyuda(state, null);
                } else {
                  mutations.M_AsignaElListadoDeAyuda(state, respuesta.data.Permisos);
                }
              }
            })
            .catch(exception => { });
        }

        if(data.ModuloId != undefined && data.ModuloId != null &&
          data.FuncionId != undefined && data.FuncionId != null &&
          data.EsRequeridoValidacionDeInstitucion != undefined && data.EsRequeridoValidacionDeInstitucion != null) {
          if (data.comprobacionDeLocalStorage.headers.Authorization != "Authentication-Authorized")
            comun.SeEstaRecargandoLaSesion(false);

          await mutations.M_ObtenPermisosDeLaVentana(state, data)
            .then(respuesta => {
              if(respuesta == undefined){
                state.Login_TareasCumplidas.ObligarAMoverseAAlgunaPagina = null;
              } else if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                state.Login_TareasCumplidas.ObtenPermisoDeLaVentana = false;
  
                data.aDondeSeRuteaOElError = respuesta.data.Error.MensajeId;
                mutations.M_ReglasDeRuteo(state, data);
              } else {
                state.Login_TareasCumplidas.ObtenPermisoDeLaVentana = true;
                if(!respuesta.data.EstaAutorizado) {
                  comun.mensajeDeAlerta("La parte del sistema que intento acceder no esta autorizado.", null, null);
                  state.Login_TareasCumplidas.ObligarAMoverseAAlgunaPagina = enumeraciones.RutaEsRedirigidaPor.NoTieneSesion;
                }
              }
            })
            .catch(exception => { });
        }
      }
    
      resultado(state.Login_TareasCumplidas);
    })
    .then(respuesta => {
      return respuesta
    })
    .catch(exception => { });;
  },
  async M_ValidaSesion(state, data) {
    return axios.post(
      api.conexion + api.Login.funcion.ObtenDatosGeneralesDeLaSesion,
      {},
      data.comprobacionDeLocalStorage
      ).then(respuesta => {
        return respuesta;
      }
      ).catch(excepcion => {
        console.log(excepcion);
        const parametrosParaVerificar = {
          ValidarUsuario: true,
          ValidarSistemaQueIngreso: true
        };
        mutations.M_SeNecesitaVerificarLaSesionDelUsuario(state, parametrosParaVerificar);
        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
      });
  },
  async M_ObtenPermisosDelSistema(state, data) {
    return axios.post(
      api.conexion + api.Login.funcion.ValidaYObtenPermisosDelSistema,
      { Sistema: data.SistemaQueSeIngreso },
      data.comprobacionDeLocalStorage
      ).then(respuesta => {
        return respuesta;
      }
      ).catch(excepcion => {
        console.log(excepcion);
        const parametrosParaVerificar = {
          ValidarUsuario: true,
          ValidarSistemaQueIngreso: true
        };
        mutations.M_SeNecesitaVerificarLaSesionDelUsuario(state, parametrosParaVerificar);
        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
      });
  },
  async M_ObtenPermisosDeLaVentana(state, data) {
    return axios.post(
      api.conexion + api.Login.funcion.ValidaQueElUsuarioTengaPermisoParaVerLaVentana,
      {
        Sistema: data.SistemaQueSeIngreso,
        ModuloId: data.ModuloId,
        FuncionId: data.FuncionId,
        EsRequeridoValidacionDeInstitucion: data.EsRequeridoValidacionDeInstitucion
      },
      data.comprobacionDeLocalStorage
      ).then(respuesta => {
        return respuesta;
      }
      ).catch(excepcion => {
        console.log(excepcion);
        router.go(-1);
        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
      });
  }, 
  async M_AsignaElListadoDeAyuda(state, data) {
    state.Login_ListadoDeAyuda = [];

    let sinCuenta = false;
    let listadoDePermisos = [];

    if (data != null) {
      listadoDePermisos = data;
      sinCuenta = true;
    } else {
      listadoDePermisos = state.Login_PermisosDelSistema;
    }

    listadoDePermisos.forEach(modulo => {
      if (!sinCuenta) {
        //if (state.Login_Meta != undefined && state.Login_Meta != null && state.Login_Meta.ModuloId != undefined && state.Login_Meta.ModuloId != null && state.Login_Meta.ModuloId == modulo.ModuloId) {
          if (modulo.RutaDeAyuda != null && modulo.RutaDeAyuda != "")
            state.Login_ListadoDeAyuda.push({
                "Nombre" : modulo.Nombre, 
                "Ruta" : modulo.RutaDeAyuda 
              });
        //}
      }

      modulo.Funciones.forEach(funcion => {
        if (state.Login_Meta != undefined && state.Login_Meta != null && state.Login_Meta.FuncionId != undefined && state.Login_Meta.FuncionId != null && state.Login_Meta.FuncionId == funcion.FuncionId) {
          if (funcion.RutaDeAyuda != null && funcion.RutaDeAyuda != "")
            state.Login_ListadoDeAyuda.push({
              "Nombre" : funcion.Nombre, 
              "Ruta" : funcion.RutaDeAyuda 
            });
        }
      });
    });
  }
}

const actions = {
  A_ReglasDeRuteo: ({ commit }, data) => {
    commit('M_ReglasDeRuteo', data);
  },
  A_ComprobarSesionEnLocalStorage: ({ commit }, data) => {
    commit('M_ComprobarSesionEnLocalStorage', data);
  },
  A_IniciarYCrearLaSesionEnLocalStorage: ({ commit }, data) => {
    commit('M_IniciarYCrearLaSesionEnLocalStorage', data);
  },
  A_ConfirmacionParaCerrarSesion: ({ commit }, data) => {
    commit('M_ConfirmacionParaCerrarSesion', data);
  },
  A_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema: ({ commit }, data) => {
    commit('M_ValidaSesionObtenDatosGeneralesObtenPermisosDelSistema', data);
  }
}

const Login = {
  State: state,
  Getters: getter,
  Mutations: mutations,
  Actions: actions
}
export default Login;



// WEBPACK FOOTER //
// ./src/store/Login.js